<template>
  <div>
    <v-textarea
      v-model.trim="question.selectedAnswer"
      class="mx-2"
      :label="$t('poll.lblAnswer')"
      rows="5"
      :disabled="isReadOnly"
      :rules="question.isMandatory ? [requiredRules] : []"
      :max="10000"
      maxlength="10000"
      counter="10000"
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: "TextTypeChoice",
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: [Number, String, Array, Object],
    },
    isReadOnly: { type: Boolean, default: false },
  },
  methods: {
    requiredRules(value) {
      return !!value || this.$t('poll.ruleAnswerReq');
    },
  },
};
</script>

<style>
</style>